import React from 'react';
import './InputField.scss';

const InputField = ({
  id,
  type = 'text', // text, fullname, email, tel
  name,
  label,
  value,
  onChange,
  onBlur,
  required = false,
  placeholder = '',
  dataType,
  className = '',
  autoComplete = '',
  size = '310',
  dataComponent,
  isFullName = false,
  fullNameValues = { first: '', last: '' },
  fullNameOnChange,
  /** When true with `isFullName`, skip the top question label (use a section header in the parent). */
  fullNameHideMainLabel = false,
  firstNameFieldLabel = 'FIRST NAME',
  lastNameFieldLabel = 'LAST NAME',
}) => {
  const baseClassName = 'form-textbox';
  const validationClass = required ? `validate[${type === 'email' ? 'Email,' : ''}required]` : '';
  const customClass = type === 'tel' ? 'mask-phone-number' : '';

  const renderInput = () => {
    if (isFullName) {
      const firstSublabelId = `sublabel_${id}_first`;
      const lastSublabelId = `sublabel_${id}_last`;
      const showFirstLabel = Boolean(firstNameFieldLabel);
      const showLastLabel = Boolean(lastNameFieldLabel);
      return (
        <div data-wrapper-react="true">
          <span className="form-sub-label-container" style={{ verticalAlign: 'top' }} data-input-type="first">
            {showFirstLabel ? (
              <label className="fullname-field-label" htmlFor={`first_${id}`} id={firstSublabelId}>
                {firstNameFieldLabel}
                {required ? <span className="form-required">*</span> : null}
              </label>
            ) : null}
            <input
              type="text"
              id={`first_${id}`}
              name={`${name}[first]`}
              className={`${baseClassName} ${validationClass}`}
              autoComplete={`section-input_${id} given-name`}
              size="10"
              placeholder={showFirstLabel ? '' : 'First Name'}
              data-component="first"
              aria-labelledby={showFirstLabel ? firstSublabelId : `label_${id}`}
              value={fullNameValues.first}
              onChange={(e) => fullNameOnChange('first', e.target.value)}
              required={required}
            />
          </span>
          <span className="form-sub-label-container" style={{ verticalAlign: 'top' }} data-input-type="last">
            {showLastLabel ? (
              <label className="fullname-field-label" htmlFor={`last_${id}`} id={lastSublabelId}>
                {lastNameFieldLabel}
                {required ? <span className="form-required">*</span> : null}
              </label>
            ) : null}
            <input
              type="text"
              id={`last_${id}`}
              name={`${name}[last]`}
              className={`${baseClassName} ${validationClass}`}
              autoComplete={`section-input_${id} family-name`}
              size="15"
              placeholder={showLastLabel ? '' : 'Last Name'}
              data-component="last"
              aria-labelledby={showLastLabel ? lastSublabelId : `label_${id}`}
              value={fullNameValues.last}
              onChange={(e) => fullNameOnChange('last', e.target.value)}
              required={required}
            />
          </span>
        </div>
      );
    }

    const inputProps = {
      type,
      id: type === 'tel' ? `input_${id}_full` : `input_${id}`,
      name,
      className: `${baseClassName} ${validationClass} ${customClass} ${className}`.trim(),
      autoComplete,
      style: { width: `${size}px` },
      size,
      placeholder,
      'data-component': dataComponent,
      'aria-labelledby': `label_${id}`,
      value,
      onChange,
      onBlur,
      required,
    };

    if (dataType) {
      inputProps['data-type'] = dataType;
    }

    return type === 'tel' ? (
      <span className="form-sub-label-container" style={{ verticalAlign: 'top' }}>
        <input {...inputProps} />
      </span>
    ) : (
      <input {...inputProps} />
    );
  };

  const showMainLabel = !(isFullName && fullNameHideMainLabel);

  return (
    <li
      className={`form-line input-question-wrapper${required ? ' jf-required' : ''}`}
      data-type={`control_${isFullName ? 'fullname' : type}`}
      id={id}
    >
      {showMainLabel ? (
        <label
          className="form-label form-label-top form-label-auto input-question name-fields"
          htmlFor={isFullName ? `first_${id}` : type === 'tel' ? `input_${id}_full` : `input_${id}`}
          id={`label_${id}`}
          aria-hidden="false"
        >
          {label}
          {required && <span className="form-required">*</span>}
        </label>
      ) : (
        <span id={`label_${id}`} className="sr-only">
          {label}
          {required ? ' (required)' : ''}
        </span>
      )}
      <div
        id={`cid_${id}`}
        className="form-input-wide"
        data-layout={isFullName ? 'full' : 'half'}
        role={isFullName && fullNameHideMainLabel ? 'group' : undefined}
        aria-labelledby={isFullName && fullNameHideMainLabel ? `label_${id}` : undefined}
      >
        {renderInput()}
      </div>
    </li>
  );
};

export default InputField; 